import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { authService } from "@/services";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login");
      return;
    }

    const sessionId = match[1];

    (async () => {
      try {
        const data = await authService.googleSession(sessionId);
        login(data);
        // Clear the hash and navigate
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { state: { user: data } });
      } catch {
        navigate("/login");
      }
    })();
  }, [navigate, login]);

  return (
    <div className="min-h-screen bg-[#E3F2FD] dark:bg-[#0a1428] flex items-center justify-center">
      <div className="text-center">
        <div className="w-8 h-8 border-4 border-[#38B6FF] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-[#1A237E] dark:text-[#E3F2FD] font-semibold">Signing you in...</p>
      </div>
    </div>
  );
}
